<template>
  <div class="s-index-container common-container">
    <top-nav ref="sTopNav" :style="{ background: navColor }"></top-nav>
    <div class="s-banner-wrap">
      <img src="../assets/image/index/banner.jpg" alt class="s-banner-img" />
    </div>
    <div class="system-switch-btn" @click="goNewSystem" style="top: 61%">
      <img src="../assets/image/index/system-switch-icon.png" alt="">
      <span>进入新版社会化服务平台</span>
    </div>
    <div class="s-banner-text" id="bannerText"></div>
    <div class="s-search-wrap" v-show="show">
      <div class="s-search-ele">
        <div class="s-search-select">
          <img src="../assets/image/index/searchTea.png" alt />
          <span></span>
        </div>
        <div class="s-search-input">
          <input type="text" v-model="searchInputValue" placeholder="茶叶专业问题咨询" />
        </div>
        <div class="s-search-button">查询</div>
      </div>
      <div class="s-search-history">
        <span class="s-search-history-title">热点关键词：</span>
        <span class="s-search-history-item">施肥</span>
        <span class="s-search-history-item">施肥</span>
        <span class="s-search-history-item">施肥</span>
        <span class="s-search-history-item">施肥</span>
        <span class="s-search-history-item">施肥</span>
        <span class="s-search-history-item">施肥</span>
      </div>
    </div>
    <div class="s-tea-price-data-wrap">
      <div class="s-tea-price-item" v-for="item in teaPriceData" :key="item.id">
        <div class="s-tea-price">{{ item.price }}</div>
        <div class="s-tea-name">{{ item.varietiesName }} （{{item.specifications}}）</div>
        <div class="s-tea-gains">
          <div v-show="item.increase && item.increase < 0">
            跌幅：
            <span class="grren">{{ item.increase }}</span>
          </div>
          <div v-show="item.increase && item.increase >= 0">
            涨幅：
            <span class="red">{{ item.increase }}</span>
          </div>
        </div>
        <div class="s-tea-date">日期：{{ item.dataTime }}</div>
      </div>
    </div>
    <!--信息咨询-->
    <div class="s-information-wrap">
      <div class="s-information-box">
        <div class="s-information-item">
          <el-carousel
            :interval="5000"
            arrow="always"
            class="index-el-carousel"
            height="300px"
            style="width:100% !important;height: 300px !important;overflow-y: hidden"
          >
            <el-carousel-item v-for="(item,ind) in informationImgList" :key="ind">
              <img :src="item.img" alt class="img" />
              <div class="title">
                <p class="title_p">{{item.title}}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="s-information-item">
          <div class="title-box">
            <div class="l-item-title">
              <img src="../assets/image/index/news.png" class="title-img" alt />
              <span class="title">新闻中心</span>
            </div>
            <div class="r-item-more" @click="goPath('information')">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <ul class="list-content">
            <li
              class="list-content-li"
              v-for="(itm,ind) in newsList"
              :key="ind"
              @click="goInfoPath(itm)"
            >
              <div class="l-title" :title="itm.informationTitle || '--'">
                <i class="li-point"></i>
                {{itm.informationTitle || '--'}}
              </div>
              <div class="r-date">{{itm.uploadDate}}</div>
            </li>
          </ul>
        </div>
        <div class="s-information-item">
          <div class="title-box">
            <div class="l-item-title">
              <img src="../assets/image/index/notice.png" class="title-img" alt />
              <span class="title">通知公告</span>
            </div>
            <div class="r-item-more" @click="goPath('information')">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <ul class="list-content list-content-especially">
            <li
              class="list-content-li list-content-li-especially"
              v-for="(itm,ind) in noticeList"
              :key="ind"
              @mouseover="hoverOn(ind)"
              @mouseout="hoverOut(ind)"
              @click="goInfoPath(itm)"
            >
              <div
                class="l-title"
                v-show="hoverType != ind"
                @mouseover="hoverOn(ind)"
                @mouseout="hoverOut(ind)"
                :title="itm.informationTitle || '--'"
              >
                <i class="li-point"></i>
                {{itm.informationTitle || '--'}}
              </div>
              <div
                class="r-date"
                v-show="hoverType != ind"
                @mouseover="hoverOn(ind)"
                @mouseout="hoverOut(ind)"
              >{{itm.uploadDate || '--'}}</div>
              <div v-show="hoverType == ind" class="detail-box" @click="goInfoPath(itm)">
                <img :src="itm.img == null?defaultImg:imgURL+'/'+itm.img" alt class="img" />
                <div class="detail-content">
                  <div class="detail-title">{{itm.informationTitle}}</div>
                  <div class="detail" v-html="itm.informationDetailStr"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="s-information-item">
          <div class="title-box">
            <div class="l-item-title">
              <img src="../assets/image/index/policy.png" class="title-img" alt />
              <span class="title">政策法规</span>
            </div>
            <div class="r-item-more" @click="goPath('information')">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <ul class="list-content">
            <li
              class="list-content-li"
              v-for="(itm,ind) in policyList"
              :key="ind"
              @click="goInfoPath(itm)"
            >
              <div class="l-title" :title="itm.informationTitle || '--'">
                <i class="li-point"></i>
                {{itm.informationTitle || '--'}}
              </div>
              <div class="r-date">{{itm.uploadDate}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--金融保险-->
    <div class="s-financial-insurance-wrap">
      <div class="s-info-title-wrap">
        <div class="title-box">
          <div class="l-item-title">
            <img src="../assets/image/index/financial.png" class="title-img" alt />
            <span class="title">金融保险</span>
          </div>
          <div class="r-item-more" @click="goPath('financialInsurance')">
            更多
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="section w1300 marginAuto section-top20">
        <div class="sectionList" v-for="(item, index) in financialList" :key="index">
          <img :src="item.img" alt="这是银行logo图片" class="bankLogo" />
          <div class="content">
            <p class="title">
              <span>{{ item.institutionName }}-{{item.productsName}}</span>
              <el-button
                size="mini"
                class="financialApplyForBtn rl"
                @click="goBank('index', item.id)"
              >开始申请</el-button>
            </p>
            <el-row>
              <el-col :span="8" class="type-col">
                <span class="name">贷款额度：</span>
                <span class="valRed">{{ item.quotaStart }}万~{{ item.quotaEnd }}万</span>
              </el-col>
              <el-col :span="8" class="type-col">
                <span class="name">参考利率：</span>
                <span class="valRed">{{ item.rateStart }}%~{{ item.rateEnd }}%</span>
              </el-col>
              <el-col :span="8" class="type-col">
                <span class="name">贷款期限：</span>
                <span class="valnormall">{{ item.termStart }}~{{ item.termEnd }}月</span>
              </el-col>
              <el-col :span="8" class="type-col">
                <span class="name">抵押贷款：</span>
                <span class="valnormall">
                  {{
                  item.guaranteeTypeValue
                  }}
                </span>
              </el-col>
              <el-col :span="8" class="type-col">
                <span class="name">贷款对象：</span>
                <span class="valnormall">
                  {{
                  item.guaranteeTypeValue
                  }}
                </span>
              </el-col>
            </el-row>
            <h4 class="childTitle">产品简介：</h4>
            <p class="details">{{ item.introductionStr }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="s-dealmakers-wrap">
      <div class="s-info-title-wrap">
        <div class="title-box">
          <div class="l-item-title">
            <img src="../assets/image/index/deal.png" class="title-img" alt />
            <span class="title">交易撮合</span>
          </div>
          <div class="r-item-more1">
            <div class="tab-box">
              <!-- <span :class="tabActive == 0 ? 'tabActive':''" @click="changeTab(0)">交易信息</span> -->
              <!-- <span class="line"></span>
              <span :class="tabActive == 1 ? 'tabActive':''" @click="changeTab(1)">撮合信息</span>-->
            </div>
            <div class="more" @click="goPath('dealmakers')">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="s-dealmakers-table-wrap">
        <!--交易-->

        <!--撮合-->
        <div
          class="s-transaction-item"
          v-for="(item,index) in matchInfoData"
          :key="index"
          @click="goDealDeatils('matchUpDetails',item)"
        >
          <div class="stateBox" v-if="item.promotion == 1">
            <img src="../assets/image/dealmakers/tuiguang.png" alt />
          </div>
          <div class="s-transaction-img">
            <img :src="item.img==null?defaultImg:item.img" alt />
          </div>
          <div class="s-transaction-info">
            <div class="s-transaction-info-title">{{item.transactionTitle}}</div>
            <div class="s-transaction-info-type">
              <span class="bg-type bg-green">{{item.matchUpType || '--'}}</span>
              <span class="bg-red">{{item.transactionNumber || '--'}}{{item.numberUnit}}</span>
              <span
                class="bg-type"
                v-show="item.dataStatus !=0"
                :class="item.dataStatus !=null && item.dataStatus !='' && item.dataStatus == '1'? 'bg-gray':
                item.dataStatus !=null && item.dataStatus !='' && item.dataStatus == '2'?'bg-blue':''"
              >{{item.dataStatus == 1?'已关闭':(item.dataStatus == 0?'正常':(item.dataStatus == 2?'已完成':'--'))}}</span>
            </div>
            <div class="s-transaction-info-price">
              <span class="price">￥{{item.transactionPrice || '--'}}</span>
              <span class="unit">{{item.priceUnit}}</span>
            </div>
            <div
              class="s-transaction-info-address"
            >地址：{{item.proninceValue}}{{item.cityValue}}{{item.countyValue}}{{item.address}}</div>
            <!-- <div class="s-transaction-info-bottom">
              <div class="s-transaction-info-name">{{item.contacts}}</div>
              <div class="s-transaction-info-date">{{item.transactionDate}}</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="s-expert-dvice-wrap">
      <div class="s-info-title-wrap">
        <div class="title-box">
          <div class="l-item-title">
            <img src="../assets/image/index/professor.png" class="title-img" alt />
            <span class="title">专家服务</span>
          </div>
          <div class="r-item-more" @click="goPath('professionalInfoConsultation')">
            更多
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <!-- <el-carousel>
      <el-carousel-item v-for="ele in expertNum" :key="ele">-->
      <div class="s-expert-dvice-list">
        <!-- <div class="s-expert-dvice-item" v-for="(item, index) in expertList[ele - 1]" :key="index"></div> -->
        <div
          class="s-expert-dvice-item"
          v-for="(item, index) in expertList"
          :key="index"
          @click="handleConsulting(item)"
        >
          <div class="s-expert-dvice-img">
            <img :src="imgURL + '/' + item.headImg" alt />
          </div>
          <div class="s-expert-desc">
            <div class="s-expert-name">{{ item.expertName || "--" }}</div>
            <div class="s-expert-work">
              <!-- <div> -->
              <span class="s-expert-title">单位：</span>
              <span class="s-expert-text">
                {{
                item.workplace || "--"
                }}
              </span>
              <!-- </div> -->
            </div>
            <div class="s-expert-work" style="border-bottom: 1px solid #DDD;">
              <span class="s-expert-title">职称：</span>
              <span>{{ item.title }}</span>
            </div>

            <div class="s-expert-content">
              <span class="s-expert-title">简介：</span>
              <span :title="item.expertIntroduction">{{ item.expertIntroduction || "暂无简介！" }}</span>
            </div>
            <!-- <div v-if="isExpert === false" class="s-expert-btn" @click="handleConsulting(item)">
                  开始咨询
            </div>-->
          </div>
        </div>
      </div>
      <!-- </el-carousel-item>
      </el-carousel>-->
    </div>
    <footer-nav></footer-nav>
    <!-- <registerLogin></registerLogin> -->
  </div>
</template>
<script>
import topNav from "../components/topNav.vue";
// import  registerLogin from "../components/registerLogin.vue";
import footerNav from "../components/footerNav.vue";
import commonEcharts from "../utils/js/commobEcharts";
import {
  getTransactionInformation,
  getMatchUpInformation,
  getInformation,
  getVarietiesNewestData,
  getExpertServices,
  getFinanceInsurancePage
} from "./../utils/api/index";
import { getFinancialProductsListPage } from "../utils/api/financialInsurance";
import eventBus from "../utils/js/eventBus.js";
export default {
  name: "index",
  components: { topNav, footerNav },
  computed: {
    windowHeight() {
      return window.screen.height;
    }
  },
  data() {
    return {
      show: false, // 隐藏首页banner图上的搜索框
      scroll: 0,
      navColor: "",
      expertList: [],
      expertNum: 1,
      searchSelectData: [
        {
          label: "企业",
          value: "企业"
        }
      ],
      tabList: [
        { name: "新闻舆情", id: 0 },
        { name: "通知公告", id: 1 }
      ],
      currentTab: "新闻舆情",
      searchSelectValue: "企业",
      searchInputValue: "",
      announcementList: [
        {
          id: 0,
          msg: "福安市茶产业发展中心关于征集名优茶品鉴样品的通知"
        }
      ],
      financialInsuranceList: [],
      radingInfoData: [], // 交易信息数据
      matchInfoData: [], // 撮合信息数据
      informationList: [], // 新闻资讯
      teaPriceData: [], // 价格数据
      loginDialog: false,
      isExpert: false,
      defaultImg: require("../assets/image/dealmakers/default.png"),
      informationImgList: [
        //信息咨询模块的轮播图
      ],
      newsList: [],
      policyList: [],
      hoverType: null,
      noticeList: [],
      financialList: [],
      imgUrlIn: "",
      tabActive: "0"
    };
  },
  created() {
    this.isExpert = JSON.parse(this.$store.state.isExpert);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getDynamicText();
    this.getMatchUpInformation(); // 交易信息列表
    this.getMatchUpInformation(); // 撮合信息列表
    this.getInformation("新闻中心"); // 新闻列表
    this.getInformation("通知公告"); // 通告列表
    this.getInformation("政策法规"); // 政策法规列表
    this.getVarietiesNewestData(); // 查询最新的品种价格上报信息
    this.getExpertServices(); // 专家列表
    // this.getFinanceInsurancePage();
    this.getFinancialProductsListPage();
    eventBus.$on("loginClick", msg => {
      this.loginDialog = true;
    });
  },
  methods: {
    goNewSystem(){
      window.location = this.newSystemUrl
      // window.open("https://nktea.fankjt.com:8443/fa-developmentservices/#/index")
    },
    hoverOn(val) {
      this.hoverType = val;
    },
    hoverOut(val) {
      this.hoverType = null;
    },
    changeTab(val) {
      this.tabActive = val;
    },
    goDealDeatils(path, item) {
      this.$router.push({ path: path, query: { id: item.id } });
    },
    // 页面滚动，导航显示背景颜色
    handleScroll() {
      //或者使用document.querySelector('.class或者#id').scrollTop
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 100) {
        this.navColor = "#3ba756";
      } else {
        this.navColor = "";
      }
      // console.log(this.scroll);
    },
    // 交易信息列表
    async getTransactionInformation() {
      let params = {
        currentPage: 1,
        pageSize: 4
      };
      let res = await getTransactionInformation(params);
      if (res.data.code == 0) {
        this.radingInfoData = res.data.data.records;
        this.radingInfoData.forEach(item => {
          if (item.img != null && item.img != "") {
            let imgList = item.img.split(",");
            for (let i = 0; i < imgList.length; i++) {
              if (imgList[i].indexOf("http") == -1) {
                imgList[i] = this.imgURL + imgList[i];
              }
            }
            item.img = imgList[0];
          }
        });
      }
    },
    // 撮合信息列表
    async getMatchUpInformation() {
      let params = {
        currentPage: 1,
        pageSize: 4
      };
      let res = await getMatchUpInformation(params);
      if (res.data.code == 0) {
        this.matchInfoData = res.data.data.records;
        this.matchInfoData.forEach(item => {
          if (item.img != null && item.img != "") {
            let imgList = item.img.split(",");
            for (let i = 0; i < imgList.length; i++) {
              if (imgList[i].indexOf("http") == -1) {
                imgList[i] = this.imgURL + imgList[i];
              }
            }
            item.img = imgList[0];
          }
        });
      }
    },
    // 信息资讯列表
    async getInformation(type) {
      let params = {
        currentPage: 1,
        pageSize: 6,
        informationType: type
      };
      let res = await getInformation(params);
      if (res.data.code == 0) {
        // this.informationList = res.data.data.records;
        // this.informationList.forEach((item) => {
        //   item.uploadDate = item.uploadDate.split(" ")[0];
        // });

        if (type == "新闻中心") {
          this.newsList = res.data.data.records;
          if (this.newsList.length > 0) {
            this.newsList.forEach(item => {
              item.uploadDate = item.uploadDate.split(" ")[0];

              if (item.img == "" || item.img == null) {
                // this.informationImgList.push({
                //     img:this.defaultImg,
                //     title:item.informationTitle
                // })
                console.log("无图片");
              } else if (item.img.includes("http") == true) {
                this.informationImgList.push({
                  img: item.img.split(",")[0],
                  title: item.informationTitle
                });
              } else {
                this.informationImgList.push({
                  img: this.imgURL + "/" + item.img.split(",")[0],
                  title: item.informationTitle
                });
              }
            });
          }
        } else if (type == "通知公告") {
          this.noticeList = res.data.data.records;
          if (this.noticeList.length > 0) {
            this.noticeList.forEach(item => {
              item.uploadDate = item.uploadDate.split(" ")[0];
            });
          }
        } else if (type == "政策法规") {
          this.policyList = res.data.data.records;
          if (this.policyList.length > 0) {
            this.policyList.forEach(item => {
              item.uploadDate = item.uploadDate.split(" ")[0];
            });
          }
        }
      }
    },
    // 查询最新的品种价格上报信息
    async getVarietiesNewestData() {
      let res = await getVarietiesNewestData();
      if (res.data.code == 0) {
        if (res.data.data.length > 5) {
          for (let i = 0; i < res.data.data.length; i++) {
            if (i <= 5) {
              this.teaPriceData.push(res.data.data[i]);
            }
          }
        } else {
          this.teaPriceData = res.data.data;
        }
      }
    },
    // 专家列表
    async getExpertServices() {
      let res = await getExpertServices({ currentPage: 1, pageSize: 4 });
      if (res.data.code == 0) {
        // if (res.data.data.length > 4) {
        //   this.expertNum = Math.ceil(res.data.data.length / 4);

        //   this.expertList = this.getNewArray(res.data.data, 4);
        // } else {
        //   this.expertNum = 1;
        //   this.expertList[0] = res.data.data;
        // }
        this.expertList = res.data.data.records;
      }
    },
    getNewArray(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    //  var arr= [1,2,3,4,5,6,7,8,9,10,11,12];;
    //  var nArr= getNewArray(arr, 8);
    //得到的nArr数组为：
    // nArr[[1,2,3,4,5,6,7,8],[9,10,11,12]]

    handleTab(item) {
      this.currentTab = item.name;
    },
    // 动态字体echarts
    getDynamicText() {
      commonEcharts.textChart("bannerText");
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "warning-row";
      }
      return "";
    },
    //银行申请
    goBank(Parmas, id) {
      this.$router.push({
        path: "financialInsuranceApplyFor",
        query: { id: id, from: Parmas }
      });
    },
    goInfoPage() {
      this.$router.push({ path: "information" });
    },
    //咨询详情
    goInfoPath(item) {
      this.$router.push({
        path: "/informationDetail",
        query: { id: item.id }
      });
    },
    async getFinanceInsurancePage() {
      let data = {};
      let res = await getFinanceInsurancePage(data);
      console.log("res保险", res);
      if (res.data.code == 0) {
        this.financialInsuranceList = res.data.data;
        this.financialInsuranceList.forEach(item => {
          if (item.img == "" || item.img == null) {
            item.img = this.defaultImg;
          } else if (item.img.includes("http") == true) {
            return item.img;
          } else {
            item.img = this.imgURL + "/" + item.img.split(",")[0];
            console.log;
          }
        });
      }
    },
    goPath(path) {
      this.$router.push({ path: path });
    },
    // 开始咨询
    handleConsulting(data) {
      this.$router.push({
        path: "professionalInfoConsultationAdvisoryDetails",
        query: { id: data.id }
      });
      // if(JSON.parse(this.$store.state.isLogin)){
      //   alert('普通用户登录')
      // }else{
      //   alert('游客')
      // }
    },
    //金融保险分页
    async getFinancialProductsListPage() {
      let params = {
        currentPage: 1,
        pageSize: 4
      };
      let res = await getFinancialProductsListPage(params);
      if (res.data.code == 0) {
        this.financialList = res.data.data.records;
        this.financialList.forEach(item => {
          if (item.img == "" || item.img == null) {
            item.img = this.defaultImg;
          } else if (item.img.includes("http") == true) {
            return item.img;
          } else {
            item.img = this.imgURL + "/" + item.img.split(",")[0];
            console.log;
          }
        });
      }
    }
  },
  //销毁,否则跳到别的路由还是会出现
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
ul,
li {
  list-style: none;
}
.s-index-container {
  width: 100%;
  overflow-x: hidden;
  .s-banner-text {
    width: 60%;
    height: 300px;
    position: absolute;
    left: 50%;
    // top: 10%;
    top: 26%;
    transform: translateX(-50%);
    z-index: 2;
  }
  .system-switch-btn{
    position: absolute;
    //top: 530px;
    transform: translateX(-50%);
    left: 50%;
    width: 316px;
    height: 63px;
    line-height: 63px;
    text-align: center;
    background: rgba(255,255,255,0.7);
    border-radius: 68px 68px 68px 68px;
    cursor: pointer;
    z-index: 8;
    img{
      vertical-align: middle;
      width: 25px;
      margin-right: 5px;
    }
    span{
      display: inline-block;
      line-height: 21px;
      vertical-align: middle;
      font-size: 20px;
      font-weight: bold;
      color: #054518;
    }
  }
  .s-banner-wrap {
    width: 100%;
    height: 100vh;
    position: relative;
    z-index: 0;
    top: 0;
    overflow: hidden;
    .s-banner-img {
      width: 100%;
      height: 100%;
    }
  }
  .s-search-wrap {
    width: 46%;
    height: 80px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .s-search-ele {
      display: flex;
      .s-search-select {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background-color: #fff;
        border-radius: 6px 0 0 6px;
        img {
          vertical-align: middle;
          width: 37px;
          height: 37px;
        }
      }
      .s-search-input {
        width: calc(100% - 200px);
        height: 80px;
        line-height: 80px;
        background-color: #fff;
        input {
          width: 100%;
          height: 50px;
          border: 0;
          border-left: 1px solid #a4cdb3;

          padding-left: 20px;
          box-sizing: border-box;
          font-size: 18px;
          letter-spacing: 1px;

          &:focus-visible {
            outline: 0;
            border: 1px solid #fff;
            border-left: 1px solid #a4cdb3;
          }
        }
        ::-webkit-input-placeholder {
          color: #798c89;
        }
      }
      .s-search-button {
        width: 130px;
        height: 80px;
        background-color: #f4aa31;
        line-height: 80px;
        font-size: 24px;
        color: #fffefe;
        cursor: pointer;
        text-align: center;
        border-radius: 0 6px 6px 0;
      }
    }
    .s-search-history {
      width: 100%;
      box-sizing: border-box;
      padding: 0 30px;
      color: #fff;
      height: 40px;
      margin-top: 20px;
      .s-search-history-title {
        font-size: 16px;
        font-weight: 700;
      }
      .s-search-history-item {
        font-size: 16px;
        padding: 5px 10px;
        border-radius: 20px;
        background-color: rgba(31, 31, 31, 0.5);
        margin-right: 30px;
        color: #fff;
      }
    }
  }
  .s-tabs-wrap {
    width: 1280px;
    margin: 0 auto;
    margin-top: 30px;
    .s-tab-title {
      height: 60px;
      line-height: 60px;
      width: 100%;
      border-bottom: #e5e5e5 1px solid;
      display: flex;
      justify-content: center;
      span {
        display: inline-block;
        width: 120px;
        color: #414141;
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
        letter-spacing: 1px;
      }
      .s-tab-active {
        color: #43aa5c;
      }
    }
  }
  .s-tea-price-data-wrap {
    width: 70%;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    color: #fff;
    display: flex;
    justify-content: space-around;
    .s-tea-price-item {
      height: 96px;
      text-align: center;
      width: 20%;
      .s-tea-price {
        font-size: 48px;
        font-family: Arial;
        font-weight: bold;
        color: #ffffff;
        text-shadow: 0px 2px 0px #0b0b0b;
      }
      .s-tea-name {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 600;
        height: 24px;
        line-height: 24px;
        color: #ffffff;
        margin-top: 15px;
      }
      .s-tea-date {
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #e2eee9;
        height: 24px;
        line-height: 24px;
        margin-top: 7px;
      }
      .s-tea-gains {
        display: flex;
        justify-content: center;
        height: 24px;
        line-height: 24px;
        margin-top: 7px;
        div {
          margin: 0 12px;
          .grren {
            color: #1cba4d;
            font-weight: 700;
          }
          .red {
            color: red;
            font-weight: 700;
          }
        }
      }
    }
    .s-tea-split {
      width: 1px;
      height: 105px;
      background-color: #fff;
      margin-top: 20px;
    }
  }

  .s-financial-insurance-wrap {
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
    .s-index-announcement {
      width: 1300px;
      height: 60px;
      background: #e6f3ef;
      border-radius: 6px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .s-announcement-carousel {
        padding: 0 8px 0 20px;
        box-sizing: border-box;
        height: 60px; //文本区域的高度
        line-height: 60px; //文本的行间距，与高度相同，则表示一行展示
        text-overflow: ellipsis; //超出内容...展示
        word-break: keep-all; //是否折断文本，keep-all表示不折断
        white-space: nowrap; //不换行展示文本
        overflow: hidden; //超出部分隐藏，与text-overflow配合使用
        flex: 1; //这个是跟左侧的图片组成的一个flex布局
        a {
          text-decoration-line: none;
          font-size: 18px;
          font-family: PingFangSC;
          font-weight: 600;
          color: #3d3d3d;
        }
        img {
          width: 26px;
          height: 26px;
          vertical-align: middle;
          margin-right: 20px;
        }
      }
      .s-more-btn {
        cursor: pointer;
        height: 60px; //文本区域的高度
        line-height: 60px; //文本的行间距，与高度相同，则表示一行展示
        width: 140px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #3d3d3d;
      }
    }
    .s-financial-insurance-list {
      width: 1300px;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .s-financial-insurance-item {
        width: 49%;
        background-color: #fff;
        border-radius: 6px;
        margin-top: 20px;
        display: flex;
        box-sizing: border-box;
        padding: 20px 10px;
        justify-content: flex-start;
        .s-financial-insurance-item-img {
          width: 30%;
          text-align: center;
          margin-right: 30px;
          img {
            width: 80%;
          }
        }
        .s-financial-insurance-item-info {
          div {
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #000000;
            margin-top: 10px;
            line-height: 24px;
            height: 24px;
            .s-financial-insurance-item-gray {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #262626;
              line-height: 24px;
              height: 24px;
            }
            .s-financial-insurance-item-red {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 600;
              color: #d02c25;
              margin-top: 10px;
            }
          }
          .s-financial-insurance-item-title {
            line-height: 24px;
            height: 24px;
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #050505;
          }
        }
      }
    }
  }
  .s-info-title-wrap {
    width: 1300px;
    margin: 0px auto;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .s-info-title {
      font-size: 24px;
      font-family: PingFangSC;
      font-weight: 600;
      color: #000000;
      text-align: center;
    }
    .s-info-title-line {
      width: 44px;
      height: 4px;
      background: #3ca757;
      border-radius: 2px;
      margin: 10px auto;
    }
    .s-info-sub-title {
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #383838;
      text-align: center;
    }
  }
  .s-dealmakers-wrap {
    width: 100%;
    min-height: 580px;
    // background-image: url("../assets/image/index/dealmakersBack.png");
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    box-sizing: border-box;
    padding: 20px;
    .s-dealmakers-table-wrap {
      width: 1300px;
      height: calc(100% - 190px);
      margin: 10px auto;
      display: flex;
      justify-content: space-around;
      // .s-dealmakers-table-title {
      //   text-align: center;
      //   font-size: 24px;
      //   font-family: PingFangSC;
      //   font-weight: 400;
      //   color: #54ae49;
      //   margin: 20px 0;
      // }

      // .s-rading-information,
      // .s-match-information {
      //   width: 49%;
      // }
      // .s-dealmakers-table {
      //   border: 1px solid #83b77d;
      //   height: 100%;
      // }
      .s-transaction-item {
        // width: 410px;
        width: 24%;
        background-color: #fff;
        margin: 10px 10px;
        border-radius: 6px;
        position: relative;
        border: 1px solid #eee;
        &:hover {
          box-shadow: 2px 3px 2px 0px #bbcabf;
        }
        cursor: pointer;
        .stateBox {
          // width: 100%;
          // height: 60px;

          position: absolute;
          top: 0px;
          left: 0px;
          // transform: rotate(23deg);
          color: #fff;
          font-size: 16px;
          text-align: center;
          display: table;
          span {
            display: table-cell;
            vertical-align: middle;
          }
          img {
            width: 100px;
          }
        }
        .s-transaction-img {
          width: 100%;
          height: 254px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .s-transaction-info {
          box-sizing: border-box;
          padding: 15px;
          .s-transaction-info-title {
            height: 40px;
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #000000;
            margin: 10px 0px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // -webkit-line-clamp: 2;
            // white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .s-transaction-info-address {
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 400;
            color: #262626;
            margin: 10px 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .s-transaction-info-bottom {
            display: flex;
            justify-content: space-between;
            div {
              font-size: 18px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #262626;
            }
          }
          .s-transaction-info-type {
            .bg-type,
            .bg-red {
              line-height: 40px;
              padding: 2px 15px;
              border-radius: 5px;
              // color: #fff;
              font-size: 15px;
              margin-right: 20px;
            }
            .bg-green {
              background-color: #d2eedc;
              color: #4bbe7a;
            }
            .bg-yellow {
              background-color: #ffedcb;
              color: #ffb22f;
            }
            .bg-red {
              background-color: #ffd1ce;
              color: #ff574f;
            }
            .bg-gray {
              background-color: #eee;
              color: #999;
            }
            .bg-blue {
              background-color: #409eff;
              color: #eee;
            }
          }
          .s-transaction-info-price {
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 400;
            color: #262626;
            margin: 10px 0px;
            .price {
              font-size: 18px;
            }
            .unit {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .s-information-wrap {
    width: 100%;
    background-color: #fff;
    padding: 40px 20px;
    .s-information-box {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .s-information-item {
      width: calc(50% - 20px);
      height: 300px;
      margin-bottom: 20px;
      // border: 1px solid #ccc;
      position: relative;
      .img {
        width: 100%;
        height: 300px;
      }
    }
    //height: 950px;
    //overflow: hidden;
  }
  .s-expert-dvice-wrap {
    width: 100%;
    background: #fff;
    padding: 20px;
    .s-expert-dvice-list {
      width: 1300px;
      margin: 0 auto;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      .s-expert-dvice-item {
        width: 24%;
        background-color: #fff;
        padding: 0 0 15px 0;
        margin-right: 10px;
        border: 1px solid #eee;
        .s-expert-dvice-img {
          width: 100%;
          height: 350px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .s-expert-desc {
          box-sizing: border-box;
          padding: 10px 20px;
          .s-expert-name {
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #000000;
            text-align: center;
            margin-bottom: 10px;
          }
          .s-expert-work {
            //display: flex;
            //justify-content: space-between;
            margin-bottom: 10px;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            div {
              line-height: 32px;
            }

            span {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #262626;
            }
            .s-expert-title {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 600;
              color: #000000;
            }
          }
          .s-expert-content {
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 400;
            color: #555555;
            line-height: 24px;
            margin-bottom: 10px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            overflow-wrap: break-word;
            display: -webkit-box;
            // text-indent: 28px;
            // white-space: nowrap; // 默认不换行；
            -webkit-line-clamp: 2; // 超出多少行
            -webkit-box-orient: vertical;
            span {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #262626;
            }
            .s-expert-title {
              font-size: 16px;
              font-family: PingFangSC;
              font-weight: 600;
              color: #000000;
            }
          }
          .s-expert-btn {
            width: 129px;
            height: 35px;
            line-height: 35px;
            background: linear-gradient(90deg, #1cba4d, #a1dc61);
            border-radius: 6px;
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            float: right;
            cursor: pointer;
          }
        }
      }
    }
  }
  .title-box {
    width: 100%;
    line-height: 40px;
    border-bottom: 1px solid #dddddd;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .l-item-title {
      padding-right: 10px;
      border-bottom: 2px solid #1cba4d;
      .title-img {
        width: 24px;
        height: 24px;
        float: left;
        margin-top: 8px;
      }
      .title {
        line-height: 40px;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #333;
        margin-left: 8px;
      }
    }
    .r-item-more {
      color: #666;
      line-height: 40px;
      cursor: pointer;
      font-size: 15px;
    }
    .r-item-more1 {
      width: 20%;
      color: #666;
      line-height: 40px;
      cursor: pointer;
      font-size: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .tab-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .line {
        width: 2px;
        height: 18px;
        display: inline-block;
        background-color: #ddd;
        margin-left: 8px;
        margin-right: 8px;
        margin-top: 10px;
      }
      .tabActive {
        font-weight: 600;
        color: #3ca757;
      }
    }
  }
  .list-content {
    height: calc(100% - 52px);
    margin-top: 10px;
    overflow: hidden;
    .list-content-li {
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      cursor: pointer;
      .l-title {
        width: 80%;
        line-height: 40px;
        font-size: 16px;
        color: #333;
        font-weight: 550;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .li-point {
          width: 6px;
          height: 6px;
          display: inline-block;
          background-color: #3ca757;
          border-radius: 3px;
          float: left;
          margin-top: 18px;
          margin-right: 8px;
        }
      }
      .r-date {
        width: 20%;
        line-height: 40px;
        font-size: 16px;
        color: #666;
        text-align: right;
      }
    }
  }
  .list-content-especially {
    overflow-y: auto;
    .list-content-li-especially {
      height: auto;
      cursor: pointer;
      .detail-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 120px;
        margin-bottom: 10px;
        .img {
          width: 120px;
          height: 120px;
        }
        .detail-content {
          width: calc(100% - 140px);
          height: 120px;
          .detail-title {
            line-height: 40px;
            color: #333;
            font-size: 16px;
            font-weight: 550;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .detail {
            line-height: 30px;
            color: #333;
            font-size: 14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }
    }
  }
  .list-content-especially::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(237, 237, 237, 0.8);
  }
  .list-content-especially::-webkit-scrollbar-track {
    border-radius: 6px;
    background-color: rgba(237, 237, 237, 0.2);
    // background-color: transparent;
  }
  .list-content-especially::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }
  .section-top20 {
    margin-top: 20px;
  }
  .section {
    min-height: 197px;
    margin-bottom: 50px;

    .sectionList {
      height: 270px;
      padding: 10px;
      display: flex;
      flex-direction: row;
      box-sizing: border-box;
      border: 1px solid #e2e2e2;
      background-color: #fff;
      box-shadow: 5px 7px 15px 0px rgba(225, 225, 225, 0.3);
      margin-bottom: 30px;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        box-shadow: 2px 3px 2px 0px #bbcabf;
      }
      .bankLogo {
        width: 225px;
        height: 225px;
        // border: 1px solid #ccc;
        // margin-top: 40px;
      }
      .content {
        padding-left: 25px;
        width: 1055px;
        .title {
          width: 100%;
          height: 50px;
          line-height: 50px;
          span {
            line-height: 50px;
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #000000;
          }
        }
        .childTitle {
          line-height: 40px;
          font-size: 16px;
          font-family: PingFangSC;
          font-weight: 600;
          color: #000000;
        }
        .details {
          line-height: 40px;
          font-size: 16px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #000000;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .financialApplyForBtn {
      // background: -webkit-linear-gradient(to right, #1cba4d, #a1dc61);
      // background: -o-linear-gradient(right, #1cba4d, #a1dc61);
      // background: -ms-linear-gradient(right, #1cba4d, #a1dc61);
      // background: -moz-linear-gradient(right, #1cba4d, #a1dc61);
      // background: linear-gradient(to right, #1cba4d, #a1dc61);
      background-color: #fff;
      border: 1px solid #3ca757;
      border-radius: 6px;
      font-size: 18px;
      font-family: PingFangSC;
      color: #3ca757;
      // color: #ffffff;
      line-height: 18px;
    }
    .type-col {
      line-height: 40px;
      span {
        font-family: PingFangSC;

        line-height: 40px;
      }
      .name {
        font-size: 16px;
        color: #000;
        font-weight: 600;
      }
      .valRed {
        font-size: 16px;
        color: #d02c25;
        font-weight: 600;
      }
      .valnormall {
        color: #000;
        font-size: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.s-index-container {
  .el-table .warning-row {
    background: #f6fbf6;
  }
  .el-carousel.el-carousel--horizontal {
    width: 1300px;
    height: 605px;
    margin: 0 auto;
  }
  .el-carousel__item {
    height: 605px;
  }
  .el-carousel__button {
    background-color: rgb(59, 167, 86);
  }
  .index-el-carousel {
    .el-carousel__item {
      height: 300px !important;
    }
    .el-carousel__indicators--horizontal {
      left: 75% !important;
      z-index: 2 !important;

      .el-carousel__button {
        width: 15px !important;
        height: 16px !important;
        background-color: #fff !important;
      }
    }
    .el-carousel__indicator:hover button {
      background-color: #3ba756 !important;
    }
    .el-carousel__indicator.is-active button {
      background-color: #3ba756 !important;
    }
    .title {
      width: 100%;
      position: absolute;
      top: 260px;
      line-height: 40px;
      z-index: 10000;
      background: rgba(102, 102, 102, 0.5);
      .title_p {
        line-height: 40px;
        color: #fff;
        font-size: 15px;
        width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .el-carousel__arrow {
    z-index: 2;
  }
}
</style>
